const API_BASE_URL = "/api/reports/generate";
export default API_BASE_URL;